import {
  CreateUserNeedRequestDto,
  LegacyNeedCategoryDto,
  UpdateUserNeedRequestDto,
  UpdateUserNeedSortOrderDto,
  UserNeedDto,
  UserNeedHistoryDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const needsRequests = {
  getUserNeed: EndpointDefinition.get<UserNeedDto, { id: string }>({
    name: 'getUserNeed',
    route: '/care/user-needs/:id',
  }),

  getUserNeeds: EndpointDefinition.get<UserNeedDto[], { userId: string }>({
    name: 'getUserNeeds',
    route: '/care/user-needs',
  }),

  postUserNeed: EndpointDefinition.post<
    UserNeedDto,
    CreateUserNeedRequestDto,
    null
  >({
    name: 'postUserNeed',
    route: '/care/user-needs',
  }),

  patchUserNeed: EndpointDefinition.patch<
    UserNeedDto,
    UpdateUserNeedRequestDto,
    { userNeedId: number }
  >({
    name: 'patchUserNeed',
    route: '/care/user-needs/:userNeedId',
  }),
  deleteUserNeed: EndpointDefinition.delete<
    UserNeedDto,
    { userNeedId: number }
  >({
    name: 'deleteUserNeed',
    route: '/care/user-needs/:userNeedId',
  }),

  updateUserNeedOrder: EndpointDefinition.patch<
    UserNeedDto[],
    UpdateUserNeedSortOrderDto,
    null
  >({
    name: 'updateNeedsOrder',
    route: '/care/user-needs',
  }),

  getNeedCategories: EndpointDefinition.get<LegacyNeedCategoryDto[], null>({
    name: 'getNeedsCategories',
    route: '/care/need-categories',
  }),

  getResourcingHistory: EndpointDefinition.get<
    UserNeedHistoryDto[],
    { userNeedId: number }
  >({
    name: 'getNeedsHistory',
    route: '/care/user-needs/history/:userNeedId',
  }),
};
